import * as STD from '@emersya/mpa-std-lib';

import CM                                from '@emersya/mpa-components-manager-lib';

export interface IShortcutDescriptor {
	type? : 'down' | 'up' | 'down-up'; // default = down;
	code : string;
	scope? : string;
	method : CM.PropertyOperation.CallOperation.IDescriptor;
	selectors : string[];
};

export interface IShortcut extends Omit<IShortcutDescriptor, 'type' | 'method'> {
	type : NonNullable<IShortcutDescriptor['type']>;
	method : CM.PropertyOperation.CallOperation;
	selectors : string[];
};

export interface IShortcutsManagerComponentConfiguration extends CM.Component.IConfiguration {
	shortcuts? : IShortcutDescriptor[];
	useDebug? : boolean;
};

export class ShortcutsManagerComponent extends CM.Component<
	ShortcutsManagerComponent,
	IShortcutsManagerComponentConfiguration
>
{
	static count = 0;
	shortcuts : IShortcut[] = [];

	private async onShortcutPressed(
		shortcut : IShortcut,
		event : KeyboardEvent
	)
	{
		const currentlyHoveredComponent = (<MPAEngineApplicationComponent<any, any>> CM.root).currentlyHovered?.component;
		if (!currentlyHoveredComponent) {
			return;
		}
		const isSelected = shortcut.selectors.some(x => currentlyHoveredComponent.component_matches(x));
		if (!isSelected) {
			return;
		}
		const realEvent = STD.events.Event.fromNative(event, currentlyHoveredComponent);
		await shortcut.method.execute(this, realEvent);
	};

	currentlyPressedKeys = new Set;

	private async onKeyDown(event : KeyboardEvent) {
		// this.currentlyPressedKeys.add(event.key);
		this.currentlyPressedKeys.add(event.code);
		const sequence = Array.from(this.currentlyPressedKeys).join('+');
		const shortcuts = this.shortcuts.filter(x => (
			(x.type !== 'up') &&
			(x.code === sequence)
		));
		for (const shortcut of shortcuts) {
			await this.onShortcutPressed(shortcut, event);
		}
	};

	private async onKeyUp(event : KeyboardEvent) {
		await (<Promise<void>> <any> void 1);
		// this.currentlyPressedKeys.delete(event.key);
		this.currentlyPressedKeys.delete(event.code);
	};

	override async component_onActivationChange(event : STD.events.Event<any, CM.Component<any, any>>) {
		await super.component_onActivationChange(event);
		if (event.subType === 'enabled') {
			document.addEventListener('keydown', this.onKeyDown.bind(this));
			document.addEventListener('keyup', this.onKeyUp.bind(this));
		} else {
			document.removeEventListener('keydown', this.onKeyDown.bind(this));
			document.removeEventListener('keyup', this.onKeyUp.bind(this));
		}
	};

	addShortcut(descriptor : IShortcutDescriptor) {
		const MCVG = new CM.PropertyOperation.CallOperation(descriptor.method);
		const shortcut = Object.assign(
			{
				type : 'down'
			},
			descriptor,
			{
				method : MCVG
			}
		);
		this.shortcuts.push(shortcut);
	};

	private previouslyDisplayedDebuggedKeyPress : Element | null = null;

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IShortcutsManagerComponentConfiguration
	)
	{
		super(descriptor, configuration);
		if (ShortcutsManagerComponent.count++ !== 0) {
			this.component_throwUserError('Already one shortcuts-manager instance!');
		}
		if (configuration.useDebug) {
			document.addEventListener('keydown', (ev) => {
				const DOM = STD.DOM.factory({
					style :  {
						position :        'absolute',
						zIndex :          '550000',
						bottom :          '20px',
						right :           '20px',
						border :          '1px solid black',
						backgroundColor : 'white',
						borderRadius :    '6px',
						display :         'flex',
						flexDirection :   'row',
						overflow :        'hidden'
					},
					childs : [
						{
							text :  ev.key,
							style : {
								backgroundColor : '#bcbcbc',
								padding :         '6px 8px'
							}
						}, {
							text :  ev.code,
							style : {
								padding : '6px 8px'
							}
						}
					]
				});
				document.body.appendChild(DOM);
				if (this.previouslyDisplayedDebuggedKeyPress) {
					this.previouslyDisplayedDebuggedKeyPress.remove();
				}
				this.previouslyDisplayedDebuggedKeyPress = DOM;
				setTimeout(() => {
					if (!DOM.isConnected) {
						return;
					}
					this.previouslyDisplayedDebuggedKeyPress = null;
					DOM.remove();
				}, 2500);
			});
		}
		for (const shortcutDescriptor of configuration.shortcuts || []) {
			this.addShortcut(shortcutDescriptor);
		}
	};
};
export namespace NS {
	export const Component = ShortcutsManagerComponent;
	export type Component = ShortcutsManagerComponent;
	export type Configuration = IShortcutsManagerComponentConfiguration;
}
;
import { MPAEngineApplicationComponent } from '../mpa-engine/Application/MPAEngineApplication';

CM.declare({
	id :   'shortcuts-manager',
	type : ShortcutsManagerComponent
});
